import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react-lite';
import { ReactElement, useCallback, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLoader } from '../../../../__legacy__/helpers/useLoader';
import { ICurrentWorkspaceStore } from '../../../workspaces/currentWorkspace/CurrentWorkspace.store';
import { AnnotatingOverviewWidget } from './AnnotatingOverview';
import { IProjectOverviewBl } from './projectOverview.bl';

export const AnnotatingOverviewContainer = observer((): ReactElement => {
  const projectOverviewBl = useInjection(IProjectOverviewBl.$);
  const currentWorkspaceStore = useInjection(ICurrentWorkspaceStore.$);
  const { isLoading, withLoaderAsync } = useLoader();
  const { projectId } = useParams<{ projectId: string }>();

  const fetchData = useCallback(async () => {
    await withLoaderAsync(async () => {
      await projectOverviewBl.getProjectDetailsAnnotatingAsync(projectId);
    }, 'project-overview');
  }, [projectId]);

  useEffect(() => {
    void fetchData();
  }, [fetchData]);

  const store = projectOverviewBl.store;

  return (
    <AnnotatingOverviewWidget
      isLoading={isLoading}
      projectId={projectId}
      acceptedCount={store.acceptedCount}
      draftsCount={store.draftsCount}
      totalImageCount={store.totalImageCount}
      waitingForAnnotationCount={store.waitingForAnnotationCount}
      toReviewCount={store.toReviewCount}
      workspaceId={currentWorkspaceStore.currentWorkspace.id}
    />
  );
});
